import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from './menu-item.interface';

@Component({
  selector: 'app-menu-submenu',
  template: `
    <mat-expansion-panel (opened)="setMenuState(item.title, true)" (closed)="setMenuState(item.title, false)"
      [expanded]="getMenuState(item.title)"
      [ngClass]="{'mat-expansion-panel-start-border': getMenuState(item.title)}">

      <mat-expansion-panel-header>
        <ion-item lines="none" color="transparent">
          <ion-icon slot="start" [name]="item.icon.name" *ngIf="item.icon.name">
          </ion-icon>
          <ion-icon slot="start" [src]="item.icon.src" *ngIf="item.icon.src"></ion-icon>
          <ion-label>{{item.title}}</ion-label>
        </ion-item>
      </mat-expansion-panel-header>

      <div class="mat-accordion-content ion-padding-start">
        <div *ngFor="let page of item.menu; let i = index">
          <div *ngIf="page.menu?.length; else menuItem">
            <app-menu-submenu [item]="page"></app-menu-submenu>
          </div>
          <ng-template #menuItem>
            <app-menu-item [item]="page" (onItemClick)="onItemMenuClick($event)"></app-menu-item>
          </ng-template>
        </div>
      </div>

    </mat-expansion-panel>`,
  styles: [],
})
export class MenuSubmenuComponent {
  @Input() item: MenuItem = { title: '' }
  @Output() onItemClick = new EventEmitter();
  private menuState: any;

  constructor() {
    this.menuState = JSON.parse(localStorage.getItem("menuState")) || { "-1": false };
  }

  persistMenuState() {
    const stateJson = JSON.stringify(this.menuState);
    localStorage.setItem("menuState", stateJson);
  }

  getMenuState(index: string) {
    try {
      return this.menuState[index] || false;
    } catch (error) {
      return false;
    }
  }

  setMenuState(index: string, state: boolean) {
    this.menuState[index] = state
    this.persistMenuState()
  }

  onItemMenuClick(ev: Event) {
    this.onItemClick.emit(ev)
  }

}
